<template>
  <span class="cpnt-mper" :id="cpntId">
    <button ref="btMper" class="btn btn-default btn-sm" title="Clique aqui para personalizar a tabela." @click="cpntMperMostrar">
      <slot name="cpnt-mper-icone">
        <svg class="fa fa-cog"></svg>
      </slot>
    </button>

    <!-- CONTEUDO -->
    <RF-Dialog-Referencia v-if="mostrarMPer === true" :cpntElement="$refs.btMper" :cpntOnFechar="cpntMperMostrar" :cpntPositionFixed="true" class="cpnt-tabela-mper">
      <template slot="titulo" v-if="cpntMper !== null">
        <div class="cpnt-mper-titulo">
          <!-- SETA O TITULO -->
          <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>
          Minha Personalização
          
          <!-- SETA O BOTÃO SALVAR -->
          <App-Button :cpntClass="'btn btn-primary btn-sm'" @onClick="() => { cpntMperSalvarMPer() }">
            Salvar
          </App-Button>
        </div>
      </template>

      <div class="cpnt-mper-fields">
        <div class="filtros" v-if="cpntMperFiltro === true">
          <!-- SETA O TITULO -->
          <span class="titulo">Filtro padrão:</span>

          <!-- SELETOR DA ORDENAÇÃO -->
          <App-Select :data-time="time"
            :cpntStatus='campos.filtro.status'
            :cpntId='campos.filtro.id'
            :cpntTabIndex='campos.filtro.tabIndex'
            :cpntNome='campos.filtro.nome'
            :cpntValue='campos.filtro.value'
            :cpntMensagem='campos.filtro.mensagem'
            :cpntMensagemTipo='campos.filtro.mensagemTipo'
            :cpntDisabled='campos.filtro.disabled'
            :cpntMostrar='campos.filtro.mostrar'
            :cpntExplica='campos.filtro.explica'
            :cpntPlaceholder='campos.filtro.placeholder'
            :cpntValueRef='campos.filtro.valueRef'
            :cpntOptionInicialNome='campos.filtro.optionInicialNome'
            :cpntOptionInicialValue='campos.filtro.optionInicialValue'
            :cpntRouter='campos.filtro.router'
            :cpntMethod='campos.filtro.method'
            :cpntField='campos.filtro.field'
            :cpntWhere='campos.filtro.where'
            :cpntAddButForm='campos.filtro.addButForm'
            :cpntKeyMostra='campos.filtro.keyMostra'
            :cpntTipoOrder='campos.filtro.tipoOrder'
            :cpntOrder='campos.filtro.order'
            :cpntOptions='campos.filtro.options'
            :cpntKeyValue='campos.filtro.keyValue'
            :cpntSearchMinimo='campos.filtro.searchMinimo'
            :cpntMask='campos.filtro.mask'

            :cpntOnBuscarOptions='campos.filtro.onBuscarOptions'
            :cpntOnChange='campos.filtro.onChange'
            :cpntOnBlur='campos.filtro.onBlur'
            :cpntOnRealizaBusca='campos.filtro.onRealizaBusca'
            :cpntOnKeyPressEnter='campos.filtro.onKeyPressEnter'
          ></App-Select>
        </div>

        <div class="rpp" v-if="cpntMperRpp !== false">
          <!-- SETA O TITULO -->
          <span class="titulo">Apresentar</span>

          <!-- SELETOR DA ORDENAÇÃO -->
          <App-Select :data-time="time"
            :cpntStatus='campos.rpp.status'
            :cpntId='campos.rpp.id'
            :cpntTabIndex='campos.rpp.tabIndex'
            :cpntNome='campos.rpp.nome'
            :cpntValue='campos.rpp.value'
            :cpntMensagem='campos.rpp.mensagem'
            :cpntMensagemTipo='campos.rpp.mensagemTipo'
            :cpntDisabled='campos.rpp.disabled'
            :cpntMostrar='campos.rpp.mostrar'
            :cpntExplica='campos.rpp.explica'
            :cpntPlaceholder='campos.rpp.placeholder'
            :cpntValueRef='campos.rpp.valueRef'
            :cpntRouter='campos.rpp.router'
            :cpntMethod='campos.rpp.method'
            :cpntField='campos.rpp.field'
            :cpntWhere='campos.rpp.where'
            :cpntAddButForm='campos.rpp.addButForm'
            :cpntKeyMostra='campos.rpp.keyMostra'
            :cpntTipoOrder='campos.rpp.tipoOrder'
            :cpntOrder='campos.rpp.order'
            :cpntOptions='cpntMperRppOptions'
            :cpntKeyValue='campos.rpp.keyValue'
            :cpntSearchMinimo='campos.rpp.searchMinimo'
            :cpntMask='campos.rpp.mask'

            :cpntOnBuscarOptions='campos.rpp.onBuscarOptions'
            :cpntOnChange='campos.rpp.onChange'
            :cpntOnBlur='campos.rpp.onBlur'
            :cpntOnRealizaBusca='campos.rpp.onRealizaBusca'
            :cpntOnKeyPressEnter='campos.rpp.onKeyPressEnter'
          ></App-Select>

          <!-- FINALIZA O TITULO -->
          <span class='titulo'>registros por página</span>
        </div>

        <div class="order" v-if="cpntMperOrder !== false">
          <!-- SETA O TITULO -->
          <span class="titulo">Ordenado por:</span>

          <!-- SELETOR DA ORDENAÇÃO -->
          <App-Select :data-time="time"
            :cpntStatus='campos.order.status'
            :cpntId='campos.order.id'
            :cpntTabIndex='campos.order.tabIndex'
            :cpntNome='campos.order.nome'
            :cpntValue='campos.order.value'
            :cpntMensagem='campos.order.mensagem'
            :cpntMensagemTipo='campos.order.mensagemTipo'
            :cpntDisabled='campos.order.disabled'
            :cpntMostrar='campos.order.mostrar'
            :cpntExplica='campos.order.explica'
            :cpntPlaceholder='campos.order.placeholder'
            :cpntValueRef='campos.order.valueRef'
            :cpntRouter='campos.order.router'
            :cpntMethod='campos.order.method'
            :cpntField='campos.order.field'
            :cpntWhere='campos.order.where'
            :cpntAddButForm='campos.order.addButForm'
            :cpntKeyMostra='campos.order.keyMostra'
            :cpntTipoOrder='campos.order.tipoOrder'
            :cpntOrder='campos.order.order'
            :cpntOptions='cpntMperOrderOptions'
            :cpntKeyValue='campos.order.keyValue'
            :cpntSearchMinimo='campos.order.searchMinimo'
            :cpntMask='campos.order.mask'

            :cpntOnBuscarOptions='campos.order.onBuscarOptions'
            :cpntOnChange='campos.order.onChange'
            :cpntOnBlur='campos.order.onBlur'
            :cpntOnRealizaBusca='campos.order.onRealizaBusca'
            :cpntOnKeyPressEnter='campos.order.onKeyPressEnter'
          ></App-Select>
        </div>

        <div class="fields">
          <!-- SETA O TITULO -->
          <span class="titulo">Mostrar as colunas marcadas na tabela:</span>

          <!-- SETA O BOTÃO PARA SELECIONAR TODOS -->
          <App-Button v-if="[ '', null, undefined ].indexOf($slots['mper-icone']) === -1"
          :cpntClass="[ 'btn', 'btn-default', 'btn-sm' ]" 
          @onClick="cpntMperOnCheckboxSelecionarTodos">
            Selecionar todos
          </App-Button>

          <!-- CHECKBOXS -->
          <div class="campos">
            <template v-for="(coluna, indexC) in colunas">
              <div v-if="coluna.mPer <= 2" :key="'mper--field--' + indexC">
                <input :id='cpntId + coluna.chave' type="checkbox" class="app-checkbox" @change="cpntMperOnCheckboxOnChange" :checked="checkbox.indexOf(coluna.chave) !== -1" :value="coluna.chave" :disabled="coluna.mPer >= 2">
                <label :for='cpntId + coluna.chave' v-html="coluna.nome"></label>
              </div>
            </template>
          </div>
        </div>
      </div>
    </RF-Dialog-Referencia>
  </span>
</template>

<style scoped>
  .cpnt-mper > button {
    margin: 3px;
  }

  .cpnt-mper-fields {
    margin-top: -8px;
  }
  .cpnt-mper-titulo > button {
    float: right;
    width: 70px;
    margin-top: -6px;
    padding: 3px;
  }
  .cpnt-mper-fields > div {
    margin: 8px 0px;
  }
  .cpnt-mper-fields > .filtros ~ .rpp,
  .cpnt-mper-fields > .rpp ~ .order,
  .cpnt-mper-fields > .order ~ .fields {
    padding-top: 8px;
    border-top: 1px solid #ccc
  }
  .cpnt-mper-fields > .filtros > .titulo,
  .cpnt-mper-fields > .rpp > .titulo,
  .cpnt-mper-fields > .order > .titulo {
    line-height: 30px;
  }
  .cpnt-mper-fields > .rpp > .cpnt-app-select {
    width: 70px;
    margin: 0px 5px;
  }
  .cpnt-mper-fields > .order > .cpnt-app-select {
    width: calc(100% - 72px - 10px);
    margin: 0px 5px;
  }
  .cpnt-mper-fields > .filtros > .cpnt-app-select {
    width: calc(100% - 72px - 10px);
    margin: 0px 5px;
  }
  .cpnt-mper-fields > .fields > button {
    float: right;
    padding: 2px 4px;
    margin-top: -2px;
    margin-right: -2px;
  }

  .cpnt-mper-fields > .fields > .campos {
    clear: both;
  }
  .cpnt-mper-fields > .fields > .campos > div {
    display: inline-block;
    width: calc(50% - 5px);
    margin-right: 5px;
  }
  .cpnt-mper-fields > .fields > .campos > div > .app-checkbox[type=checkbox] + label:before {
    margin-right: 3px;
  }
</style>

<script>
  export default {
    props: {
      cpntId: {
        required: false,
        type: String,
        default: function () {
          // INICIA A VARIAVEL ID
          var id = ''

          // INICIA PARA VERIFICAR SE ENCONTROU UM ID
          var flag = false

          // VERIFICA SE GEROU UM ID VALIDO
          while (flag === false) {
            // GERA UM ID PARA O CAMPO
            id = 'cpnt-mper-' + (Math.floor(Math.random() * 8888) + 1000).toString()

            // VERIFICA SE O ID GERADO É UNICO NA TELA
            flag = [ '', null, undefined ].indexOf(document.getElementById(id)) !== -1
          }

          // RETONAR O VALOR MONTADO
          return id
        }
      },

      cpntMper: {
        required: true,
        type: String
      },
      cpntMperRpp: {
        required: false,
        type: Boolean,
        default: function () {
          return true
        }
      },
      cpntMperOrder: {
        required: false,
        type: Boolean,
        default: function () {
          return true
        }
      },
      cpntMperField: {
        required: false,
        type: Boolean,
        default: function () {
          return true
        }
      },
      cpntMperFiltro: {
        required: false,
        type: Boolean,
        default: function () {
          return true
        }
      },

      cpntMperRppOptions: {
        required: false,
        default: function () {
          return [
            { id: '5' },
            { id: '10' },
            { id: '15' },
            { id: '20' },
            { id: '25' },
            { id: '30' },
            { id: '35' },
            { id: '40' },
            { id: '45' },
            { id: '50' },
            { id: '55' },
            { id: '60' },
            { id: '65' },
            { id: '70' },
            { id: '75' },
            { id: '80' },
            { id: '85' },
            { id: '90' },
            { id: '95' },
            { id: '100' }
          ]
        }
      },
      cpntMperOrderOptions: {
        required: false,
        default: function () {
          return [
            { id: '0', nome: 'Código Decrescente', chave: 'id', order: 'desc' },
            { id: '1', nome: 'Código Crescente', chave: 'id', order: 'asc' }
          ]
        }
      },
      cpntMperFieldOptions: {
        required: false,
        default: function () {
          return []
        }
      }
    },
    components: {
      'RF-Dialog-Referencia': () => import('@/components/rf-geral/dialog/RF-Dialog-Referencia.vue')
    },
    data: function () {
      return {
        time: '',
        mostrarMPer: false,
        checkbox: [],
        colunas: [],
        campos: {
          filtro: {
            id: this.cpntId + 'mper--filtro',
            status: '',
            nome: '',
            keyValue: 'id',
            keyMostra: [ 'nome' ],
            optionInicialNome: 'Sem padrão',
            optionInicialValue: '',
            value: '',
            options: [],
            onBuscarOptions: this.cpntMperOnBuscarFiltros,
            onChange: this.cpntMperAlterarMPerFiltro
          },
          rpp: {
            id: this.cpntId + 'mper--rpp',
            status: '',
            nome: '',
            keyValue: 'id',
            keyMostra: [ 'id' ],
            value: { id: '10' },
            onChange: this.cpntMperAlterarMPerRpp
          },
          order: {
            id: this.cpntId + 'mper--order',
            status: '',
            nome: '',
            keyValue: 'id',
            keyMostra: [ 'nome' ],
            value: '0',
            onChange: this.cpntMperAlterarMPerOrdencao
          },
        }
      }
    },
    mounted: function () {
      // CHAMA A FUNÇÃO PARA SETAR AS COLUNAS
      this.cpntMperIniciar()
    },
    methods: {
      cpntMperIniciar: function () {
        // CHAMA A FUNÇÃO PARA SETAR VALOR COLUNAS
        this.cpntMperTratarColunas()

        // CHAMA A FUNÇÃO PARA SETAR VALOR DO RPP
        this.cpntMperTratarRpp()

        // CHAMA A FUNÇÃO PARA SETAR VALOR DO ORDER
        this.cpntMperTratarOrder()
      },
      cpntMperTratarColunas: function () {
        if ([ '', null, undefined ].indexOf(this.cpntMper) === -1) {
          // PEGA A MINHA PERSONALIZAÇÃO EXISTENTE
          var tabper = this.$store.state.mPer[this.cpntMper]

          // PEGA AS COLUNAS RECEBIDAS
          var colunas = JSON.parse(JSON.stringify(this.cpntMperFieldOptions))
    
          // VERIFICA SE TEM ALGUMA PERSONALIZAÇÃO
          if (tabper.flag !== false) {
            // SETA AS COLUNAS MARCADAS
            for (var indexC in colunas) {
              // OCULTA TODAS AS COLUNAS OPCIONAIS
              if (colunas[indexC].mPer === 1) {
                colunas[indexC].mPer = 0
              }
    
              // VERIFICA SE A COLUNA DEVE SER APRESENTADA
              if (colunas[indexC].mPer === 0 && tabper.field.indexOf(colunas[indexC].chave) !== -1) {
                colunas[indexC].mPer = 1
              }
            }
          }
    
          // SETA AS COLUNAS MONTADAS
          this.colunas = colunas
        }
      },
      cpntMperTratarRpp: function () {
        if ([ '', null, undefined ].indexOf(this.cpntMper) === -1) {
          // PEGA A MINHA PERSONALIZAÇÃO EXISTENTE
          var tabper = this.$store.state.mPer[this.cpntMper]

          // PEGA AS COLUNAS RECEBIDAS
          var value = [ '', null, undefined ].indexOf(tabper.rpp) === -1 ? tabper.rpp : { id: '10' }
    
          // VERIFICA SE TEM ALGUMA PERSONALIZAÇÃO
          if ([ '', null, undefined ].indexOf(value) === -1) {
            value = this.cpntMperRppOptions.filter(item => item.id === value)[0]
          }
    
          // SETA AS COLUNAS MONTADAS
          this.campos.rpp.value = value
        }
      },
      cpntMperTratarOrder: function () {
        if ([ '', null, undefined ].indexOf(this.cpntMper) === -1 && this.cpntMperOrder !== false) {
          // PEGA A MINHA PERSONALIZAÇÃO EXISTENTE
          var tabper = this.$store.state.mPer[this.cpntMper]

          // PEGA AS COLUNAS RECEBIDAS
          var value = [ '', null, undefined ].indexOf(tabper.order) === -1 ? tabper.order : { id: '0' }
    
          // VERIFICA SE TEM ALGUMA PERSONALIZAÇÃO
          if ([ '', null, undefined ].indexOf(value) === -1) {
            value = this.cpntMperOrderOptions.filter(item => item.id === value)[0]
          }
    
          // SETA AS COLUNAS MONTADAS
          this.campos.order.value = value
        }
      },
      cpntMperBuscarValor: function () {
        return new Promise((success) => {
          this.$store.state.comunicaAPI('/config/mper/get/', 'GET', this.cpntMper, (retorno) => {
            // INICIA O VETOR DE PERSONALIZAÇÃO
            var vetor = { field: '', rpp: '10', order: '0', flag: false, filtro: '' }
  
            // VERIFICA SE EXISTE O FILTRO
            retorno.data.filtro = ''
            if ([ '', null, undefined ].indexOf(retorno.data.id_cg_filtro_j_filtro) === -1) {
              // CONVERTE O VALOR RECEBIDO
              retorno.data.id_cg_filtro_j_filtro.j_filtro = JSON.parse(retorno.data.id_cg_filtro_j_filtro.j_filtro)
  
              // PEGA O VALOR CONVERTIDO
              retorno.data.filtro = JSON.parse(JSON.stringify(retorno.data.id_cg_filtro_j_filtro))
  
              // DELETA O VALOR NÃO UTILIZADO MAIS
              delete retorno.data.id_cg_filtro_j_filtro
            }
  
            // VERIFICA SE TEM MINHA PERSONALIZAÇÃO
            var flag = Object.values(retorno.data).filter(item => [ '', null, undefined ].indexOf(item) === -1).length >= 1
  
            // VERIFICA SE FOI ENCONTRADO ALGUMA PERSONALIZAÇÃO
            if (flag === true) {
              vetor = retorno.data
              vetor.flag = true
            }
  
            // SALVA A MINHA PERSONALIZAÇÃO RECEBIDA DA API
            this.$store.commit('SET_MINHA_PERSONALIZACAO', { id: this.cpntMper, dados: vetor })
              
              // CHAMA A FUNÇÃO PARA ATUALIZAR OS VALORES 
            this.cpntMperIniciar()
  
            // CHAMA A FUNÇÃO PARA FINALIZAR O PROCESSO
            success()
          }, () => {})
        })
      },
      cpntMperMostrar: function (event) {
        if (event.type === 'click') {
          // OCULTA E MOSTRA TELA DE MINHA PERSONALIZAÇÃO
          this.mostrarMPer = !this.mostrarMPer

          // SETA OS VALORES MARCADOS
          if (this.mostrarMPer === true) {
            // LIMPA A VARIAVEL DE CHECKBOX
            this.checkbox = []

            // RODA O VETOR EM TODAS AS COLUNAS
            for (var indexC in this.colunas) {
              if ([ '', null, undefined ].indexOf(this.colunas[indexC].chave) === -1 && this.colunas[indexC].mPer >= 1 && this.colunas[indexC].mPer <= 2) {
                this.checkbox.push(this.colunas[indexC].chave)
              }
            }
          }
        }
      },
      cpntMperOnCheckboxOnChange: function (event) {
        // PEGA O NOME DA COLUNA
        var coluna = event.target.id.split('--')[1]

        // VERIFICA A AÇÃO QUE DEVE REALIZAR COM OS CHECKBOXS
        switch (event.target.checked) {
          case true:
            this.checkbox.push(event.target.value)
            break

          case false:
            this.checkbox = this.checkbox.filter(item => item !== event.target.value)
            break
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
        
        // VERIFICA SE TEM MINHA PERSONALIZAÇÃO
        if (this.cpntMper === null) {
          // PEGA O INDEX DA COLUNA
          var indexC = this.colunas.findIndex(item => item.chave === coluna)

          // VERIFICA SE A COLUNA DEVE MOSTRAR OU NÃO
          this.colunas[indexC].mPer = this.colunas[indexC].mPer === 0 ? 1 : 0
        }
      },
      cpntMperOnCheckboxSelecionarTodos: function () {
        // INICIA A VARIAVEL
        var checkbox = []

        // MONTA A VARIAVEL QUE VAI MOSTRAR TODAS AS COLUNAS
        for (var indexC1 in this.colunas) {
          if (this.colunas[indexC1].mPer >= 0 && this.colunas[indexC1].mPer <= 2) {
            checkbox.push(this.colunas[indexC1].chave)
          }
        }

        // SETA TODAS AS COLUNAS QUE DEVE MOSTRAR
        this.checkbox = checkbox

        // MONTA A VARIAVEL QUE VAI MOSTRAR TODAS AS COLUNAS
        for (var indexC2 in this.colunas) {
          if (this.colunas[indexC2].mPer === 0 && checkbox.indexOf(this.colunas[indexC2].chave) !== -1) {
            this.colunas[indexC2].mPer = 1
          }
        }
        
        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // APRESENTA A MENSAGEM DE ERRO
        this.$store.state.msgWarn('WEB [200]: Todas as colunas estão sendo exibidas na tabela.', 'success')

        // MANDA FECHAR A TELA
        this.cpntMperMostrar({ type: 'click' })
      },
      cpntMperAlterarMPerFiltro: function (value) {
        // SETA O STATUS DA TELA
        this.campos.filtro.value = value

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      cpntMperAlterarMPerRpp: function (value) {
        // SETA O STATUS DA TELA
        this.campos.rpp.value = value

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      cpntMperAlterarMPerOrdencao: function (value) {
        // SETA O STATUS DA TELA
        this.campos.order.value = value

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      cpntMperSalvarMPer: function () {
        // INICIA O FORMULARIO QUE SERÁ ENVIADO PARA API
        var formData = { model: this.cpntMper, rpp: '', order: '', ac: '', field: '' }

        // VERIFICA SE TEM FIELDS PARA SALVAR
        formData.field = this.checkbox.join(',')
        
        if (this.cpntMperRpp !== false) {
          // SETA A ORDENAÇÃO DOS CAMPOS
          formData.rpp = this.campos.rpp.value

          // VERIFICA SE É OBJETO, CONVERTE EM STRING
          formData.rpp = typeof formData.rpp === 'string' ? formData.rpp : formData.rpp.id
        }

        // VERIFICA SE EXISTE FILTRO PARA SALVAR
        if (this.cpntMperFiltro !== false) {
          // SETA A ORDENAÇÃO DOS CAMPOS
          formData.id_cg_filtro = this.campos.filtro.value

          // VERIFICA SE É OBJETO, CONVERTE EM STRING
          formData.id_cg_filtro = typeof formData.id_cg_filtro === 'string' ? formData.id_cg_filtro : formData.id_cg_filtro.id
        }

        // VERIFICA SE TEM ORDENAÇÃO
        if (this.cpntMperOrder !== false) {
          // SETA A ORDENAÇÃO DOS CAMPOS
          formData.order = this.campos.order.value

          // VERIFICA SE É OBJETO, CONVERTE EM STRING
          formData.order = typeof formData.order === 'string' ? formData.order : formData.order.id
        }

        // REALIZA A COMUNICAÇÃO COM A API
        this.$store.state.comunicaAPI('/config/mper', 'PUT', formData, (retorno) => {
          // APRESENTA A MENSAGEM RETORNADA DA API
          this.$store.state.TRATAR_RET_LOT_API(retorno)

          // REMOVE MINHA PERSONALIZAÇÃO SALVA
          this.$store.commit('REMOVE_MINHA_PERSONALIZACAO', this.cpntMper)

          // REINICIA O CARREGAMENTO DOS VALORES
          this.cpntMperBuscarValor().then(() => {
            // FECHA A TELA DA MINHA PERSONALIZAÇÃO
            this.cpntMperMostrar({ type: 'click' })
  
            // CHAMA A FUNÇÃO PARA REINICIAR O PROCESSO
            this.$emit('UPDATE')
          })
        }, () => {})
      },
    },
    watch: {
      cpntMperFieldOptions: function () {
        this.cpntMperTratarColunas()
      },
      cpntMperRppOptions: function () {
        this.cpntMperTratarRpp()
      },
      cpntMperOrderOptions: function () {
        this.cpntMperTratarOrder()
      }
    }
  }
</script>
